export const measureTreeNodeHeight = (
  element: Element,
  entry?: ResizeObserverEntry,
) => {
  const fromEntry = entry?.borderBoxSize?.[0]?.blockSize;
  if (fromEntry) return Math.round(fromEntry);

  return (element as HTMLElement).offsetHeight;
};